import api from '../api'

export const emailVerificationService = {
  async verifyEmail(token: string) {
    const response = await api.post('/verify-email', { token })
    return response.data
  },

  async resendVerification(email: string, brandId: number) {
    const response = await api.post('/resend-verification', {
      email,
      brand_id: brandId,
    })
    return response.data
  }
}
